import { Box, Button, Typography, Modal } from "@mui/material";
import { style, header } from "./modalStyles";
import { Close } from "@mui/icons-material";

const NewUpdateModal = ({ open, onClose, onClickRefresh, description }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <Box sx={header}>
          <Close onClick={onClose} />
        </Box>
        <Box>
          <Typography variant="h6" mt={6} mb={2} align="center">
            App update available
          </Typography>
          <Typography variant="body1" mb={2} align="center">
            We have an update available. Click Refresh to load
            the latest features.
          </Typography>
          {description && (
            <Typography variant="body1" mb={2} align="center">
              {description}
            </Typography>
          )}
          <Button
            onClick={onClickRefresh}
            variant="outlined"
            size="large"
            fullWidth
            mb={1}
          >
            Refresh
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default NewUpdateModal;
